import React from 'react';
import { DynamicModuleLoader } from 'redux-dynamic-modules';
import getModule from './module';
const ModuleLoader = ({ children })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicModuleLoader, {
        modules: [
            getModule()
        ]
    }), children);
};
ModuleLoader.displayName = 'ModuleLoader';
export default ModuleLoader;
